var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F8F9FA",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0264 23.0254H37.3146L36.8013 37.3986C36.7555 38.6799 35.7035 39.695 34.4214 39.695H25.9196C24.6374 39.695 23.5855 38.6799 23.5397 37.3986L23.0264 23.0254Z",
    stroke: "#DD2C2F",
    strokeWidth: 1.78603
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5977 21.835C26.5977 20.5198 27.6638 19.4536 28.979 19.4536H31.3604C32.6756 19.4536 33.7418 20.5198 33.7418 21.835V23.0257H26.5977V21.835Z",
    stroke: "#DD2C2F",
    strokeWidth: 1.78603
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6445 23.0254H39.6955",
    stroke: "#DD2C2F",
    strokeWidth: 1.78603,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5977 26.5977L26.8953 36.1232",
    stroke: "#DD2C2F",
    strokeWidth: 1.78603,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1699 26.5977V36.1232",
    stroke: "#DD2C2F",
    strokeWidth: 1.78603,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.742 26.5977L33.4443 36.1232",
    stroke: "#DD2C2F",
    strokeWidth: 1.78603,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.3bf47bef492c4d849de8c685e37298d6.svg";
export { ForwardRef as ReactComponent };